import DoctrineItem from "./_doctrineItem";
import ItemGenerico from "./_itemGenerico";
import JurisprudenceItem from "./_jurisprudenceItem";
import LegislationItem from "./_legislationItem";
import ModelItem from "./_modelItem";

import "./index.scss";

const ItemComponents = {
  jurisprudencia: {
    Component: JurisprudenceItem,
  },
  legislacao: {
    Component: LegislationItem,
  },
  doutrinas: {
    Component: DoctrineItem,
  },
  peticoes: {
    Component: ItemGenerico,
  },
  modelos: {
    Component: ModelItem,
  },
  dicionario: {
    Component: ItemGenerico,
  },
};

const ResultItem = ({
  index = 0,
  item = null,
  tipo = null,
  searchTerm = undefined,
  pushDown = false,
  cardProfileStyle = false,
  onRemove = undefined,
}) => {
  const { Component } = ItemComponents[tipo] || ItemGenerico;

  return (
    <Component
      item={item}
      index={index}
      searchTerm={searchTerm}
      pushDown={pushDown}
      cardProfileStyle={cardProfileStyle}
      onRemove={onRemove}
    />
  );
};

export default ResultItem;
